import { createSlice } from '@reduxjs/toolkit';

import type { IError } from '../../../types';

const initialState: IError = {
  code: null,
  message: null,
  type: null,
  action: null,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError(state, action): any {
      return action.payload;
    },
    resetError(): IError {
      return initialState;
    },
  },
});

// biome-ignore lint/nursery/useExplicitType: Redux Toolkit action creators are inferred
export const { setError, resetError } = errorSlice.actions;

export default errorSlice.reducer;
